<script setup>
import { ref } from 'vue'

defineProps(['faq'])

const isOpen = ref(false)
</script>
<template>
  <div
    :class="[
      'animation flex max-w-[800px] cursor-pointer flex-col overflow-hidden rounded-2xl py-4 md:px-8',
      isOpen ? 'gap-10' : 'gap-5',
    ]"
    @click="isOpen = !isOpen"
  >
    <div class="flex items-center justify-between">
      <div
        class="overflow-hidden text-ellipsis font-heading text-h6 font-semibold uppercase text-purple-300 md:text-h5"
      >
        {{ faq.question }}
      </div>
      <i :class="['fa-solid fa-plus animation rounded-full p-4', isOpen && '-rotate-45']"></i>
    </div>
    <p
      :class="[
        isOpen && 'open',
        'answer animation max-h-0 overflow-hidden font-body text-body-md font-medium text-text-muted/50',
      ]"
    >
      {{ faq.answer }}
    </p>
    <svg xmlns="http://www.w3.org/2000/svg" width="732" height="2" viewBox="0 0 732 2" fill="none">
      <path d="M0 1H732" stroke="#756AAF" stroke-width="1.5" stroke-dasharray="2 6" />
    </svg>
  </div>
</template>
<style scoped>
.answer.open {
  @apply max-h-[200px] overflow-y-auto;
}
</style>
